import { put, take, call } from 'redux-saga/effects';
import {
  getDataChartEvents as getDataChartEventsAction,
  setDataChartEventsError,
  setDataChartEvents,
} from '../../../reducers/dataChartEventsSlice';
import withLoading from '../../../sagas/loadingSaga';

export default function* dataChartEventsSaga(api) {
  while (true) {
    const getDataChartRequestedAction = yield take(getDataChartEventsAction);
    const { entityId, startDate, endDate } =
      getDataChartRequestedAction.payload;

    yield* withLoading(function* () {
      yield call(getDataChartEvents, api, entityId, startDate, endDate);
    });
  }
}

function* getDataChartEvents(api, entityId, startDate, endDate) {
  try {
    const eventsData = yield call(
      api.getEventsDataForCharts,
      entityId,
      startDate,
      endDate,
    );
    yield put(setDataChartEvents(eventsData.data));
  } catch (error) {
    yield put(setDataChartEventsError(error));
  }
}
